import { Typography } from '@material-ui/core'
import { Identifier } from 'react-admin'

// TODO: match to react admin style
const defaultStyle = {
  fontSize: '0.75rem',
  fontFamily: 'Roboto, sans-serif',
  color: '#888',
}

type IFrameProps = {
  source: Identifier | undefined
  width?: string
  height?: string
  title?: string
}

export const Iframe = ({ source, width = '1000', height = '1000', title = '' }: IFrameProps) => {
  if (!source) {
    return <div>Loading...</div>
  }

  const src = source.toString()
  return (
    <div className="embed-iframe">
      {title && (
        <Typography component="span" variant="body2" display="block" style={defaultStyle}>
          {title}
        </Typography>
      )}
      <iframe width={width} height={height} title={title} src={src}></iframe>
    </div>
  )
}
